<template>
  <v-row justify="center">
    <v-dialog v-model="activate" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">
            Nový produkt:
            <span style="color:red !important">{{name}}</span>
          </span>
        </v-card-title>
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step editable step="1" :complete="e1 > 1">Základní info</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step editable step="2" :complete="e1 > 2">Složení</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3" editable>Kontrolní body</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-container>
                <v-form ref="formOne" v-model="validOne">
                  <v-row>
                    <v-col cols="12" sm="8">
                      <v-text-field
                        v-model="name"
                        :rules="nameRules"
                        label="Název produktu"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        v-model="productNo"
                        :rules="productNoRules"
                        label="Ref. číslo produktu"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="subtitle"
                        :rules="subtitleRules"
                        :counter="30"
                        label="Popisek produktu"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row justify="center">
                  <v-btn :disabled="!validOne" color="primary" @click="e1 = 2">
                    <span>Pokračovat</span>
                    <v-icon>keyboard_arrow_right</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-container>
                <v-form ref="formTwo" v-model="validTwo" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-autocomplete
                        v-model="selectedStocks"
                        :items="stocks"
                        label="Skladové položky"
                        multiple
                        item-text="name"
                        return-object
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="remove(data.item)"
                          >{{ data.item.name }}</v-chip>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row justify="center" >
                    <v-col v-for="(stock,index) in selectedStocks" :key="stock._id" cols="8">
                      {{ index+1 }}. {{stock.name}}
                      <v-text-field
                        v-model="stocksMerged[index].count"
                        label="Počet"
                        required
                        :suffix="stock.units"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row justify="center">
                  <v-btn :disabled="!validOne" color="primary" @click="e1 = 3">
                    <span>Pokračovat</span>
                    <v-icon>keyboard_arrow_right</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="3">
              <v-container>
                <v-form ref="formThree" v-model="validTwo" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field v-model="checkpoint" label="Nový kontrolní bod výroby"><template slot="append"><v-btn color="blue darken-1" text @click="addCheck">Potvrdit</v-btn></template></v-text-field>
                    </v-col>
                    
                  </v-row>
                </v-form>
                <v-row justify="center">
                  <transition-group name="list" tag="p">
                
                  <span v-for="(check,index) in checkpoints" :key="check">{{index+1}}. {{check}} <v-icon @click="removeCheck(check)" style="cursor:pointer;margin-bottom:5px">cancel</v-icon><br></span>
                
                  </transition-group>
                </v-row>
                <v-row justify="center">
                  <v-btn :disabled="!validOne" color="primary" @click="validate">
                    <span>Uložit</span>
                    <v-icon>save</v-icon>
                  </v-btn>
                </v-row>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
          <div class="float-right pb-2 pr-2">
            <v-btn color="blue darken-1" text @click="close">Zavřít</v-btn>
          </div>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.visible" :timeout="3000">
      <v-icon>mdi-check</v-icon>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-row>
</template>

<script>
import gql from "graphql-tag";
export default {
  props: ["activate"],
  apollo: {
    stocks: {
      query: gql`
        query {
          stocks {
            _id
            name
            units
          }
        }
      `,
    },
  },
  watch: {
    selectedStocks(newVal, oldVal) {
      if (newVal > oldVal) {
        this.stocksMerged.push({
          _id: newVal[newVal.length - 1]._id,
          count: null,
        });
      } else {
        this.stocksMerged.forEach((merged) => {
          var indexOfremoved = this.selectedStocks.findIndex(
            (i) => i._id === merged._id
          );
          if (indexOfremoved < 0) {
            this.stocksMerged.splice(indexOfremoved, 1);
          }
        });
      }
    },
  },
  data() {
    return {
      e1: 1,
      checkpoint: null,
      checkpoints: [],
      suppliers: [],
      selectedStocks: [],
      stocksMerged: [],
      snackbar: {
        visible: false,
        message: "",
        icon: "mdi-check",
      },
      validOne: false,
      validTwo: false,
      validThree: false,
      name: null,
      nameRules: [],
      productNo: null,
      productNoRules: [],
      subtitle: null,
      subtitleRules: [],
    };
  },
  methods: {
    validate() {
      this.$refs.formOne.validate();
      if (this.validOne) {
        this.$apollo
          .mutate({
            // Query
            mutation: gql`
              mutation($name: String!, $subtitle: String!, $productNo: String!, $checkpoints: [String], $materials: [InputProductMaterial]) {
                createProduct(productInput: { name: $name, subtitle: $subtitle, productNo: $productNo checkpoints: $checkpoints, materials: $materials  }) {
                  name
                }
              }
            `,
            variables: {
              name: this.name,
              subtitle: this.subtitle,
              productNo: this.productNo,
              checkpoints: this.checkpoints,
              materials: this.stocksMerged,
            },
          })
          .then(() => {
            this.qlDone(true);
          })
          .catch(() => {
            this.qlDone(false);
          });
      }
    },
    qlDone(success) {
      if (success) {
        this.snackbar = {
          visible: true,
          message: "Nový produkt úspěšně zaveden",
          icon: "mdi-check",
        };
        setTimeout(() => {
          this.close();
        }, 500);
      } else {
        this.snackbar = {
          visible: true,
          message: "Chyba",
          icon: "mdi-alert-circle",
        };
      }
    },
    close() {
      this.$refs.formOne.reset();
      this.$refs.formOne.resetValidation();

      this.$emit("close-dialog", false);
      this.e1 = 1;
    },
    remove(item) {
      const index = this.selectedStocks.indexOf(item);
      if (index >= 0) this.selectedStocks.splice(index, 1);
    },
    removeCheck(item) {
      const index = this.checkpoints.indexOf(item);
      if (index >= 0) this.checkpoints.splice(index, 1);
    },
    addCheck() {
      if (this.checkpoint) {
        this.checkpoints.push(this.checkpoint);
        this.checkpoint = null;
      }
    },
  },
  mounted() {
    this.nameRules = [
      (v) => !!v || "Název je povinný",
      (v) => (v && v.length <= 30) || "Název může mít maximálně 30 znaků",
      (v) => (v && v.length > 2) || "Název musí mít minimálně 3 znaky",
    ];
    this.subtitleRules = [
      (v) => !!v || "Popisek je povinný",
      (v) => (v && v.length <= 30) || "Popisek může mít maximálně 30 znaků",
      (v) => (v && v.length > 2) || "Popisek musí mít minimálně 5 znaků",
    ];
    this.productNoRules = [
      (v) => !!v || "Ref. číslo produktu je povinné",
    ];
  },
};
</script>
<style scoped>
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>